<template>
  <m-pageframe title="Accessibility">
    <accessibility-user-feedback-form />
  </m-pageframe>
</template>

<script>
import AccessibilityUserFeedbackForm from '@/components/accessibility/user-feedback-form.vue';

export default {
  components: {
    AccessibilityUserFeedbackForm,
  },
};
</script>
